/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SiteSurveyType {
  Image = 0,
  'Main Service Disconnect Size' = 1,
  'Attic Access Information' = 2,
  'Attic Photos' = 3,
  Comment = 4,
  'Decking Details' = 5,
  'Decking Verification' = 6,
}
